import moment from 'moment';
import { createReducer } from 'typesafe-actions';
import withJobs from '../../_core/job/reducers';
import {
    ICRBStore,
} from './@types';
import crbActions, { ECRBConstants, TCRBActions } from './actions';

const defaultState: ICRBStore = {
    _jobs: {},
    currentOperation: undefined,
    records: {
        byIds: {},
        ids: [],
    },
    filter: {
        startDate: moment().subtract(7, 'days').toDate(),
        endDate: moment().add(1, 'day').toDate(),
        shownRecords: 'ALL',
		vesselId: '',
    },
};
const crbReducers = createReducer<ICRBStore, TCRBActions>(defaultState)
    .handleAction(
        crbActions.document.historySet,
        function historySet(state, action) {
            return {
                ...state,
                records: action.payload.history,
            };
        }
    )
    .handleAction(
        crbActions.document.setFilter,
        function setFilter(state, action) {
            return {
                ...state,
                filter: action.payload.filter,
            };
        }
    );

export default withJobs<ICRBStore>(
    ECRBConstants.FEATURE,
    defaultState,
    crbReducers
);
